import { ClearButton } from './ClearButton';
import { StyledClearSelectControl } from './style';

export const ClearSelectControl = ({ clearText, clearIcon, handleClearValue, disableClear }) => (
  <StyledClearSelectControl>
    <ClearButton text={clearText} icon={clearIcon} onClick={handleClearValue} disabled={disableClear} />
  </StyledClearSelectControl>
);
